/**
 * Application configuration file
 * Contains environment-specific settings
 */

// Environment configurations
const configs = {
  development: {
    apiBaseUrl: 'https://helpscout-dashboard.test/app-backend',
    debug: true
  },
  production: {
    apiBaseUrl: 'https://helpscout-dashboard.ashstonestudios.com/app-backend',
    debug: false
  }
};

// Determine current environment
const environment = import.meta.env.PROD ? 'production' : 'development';

// Export configuration for current environment
export const config = {
  ...configs[environment],
  environment
};

// For debugging purposes
if (config.debug) {
  console.log(`API URL: ${config.apiBaseUrl}`);
}

export default config;
